export type ActionInputValue = string | number

export const WITCH_ANTIDOTE_TAG = 'x-response-antidote'
export const WITCH_POISON_TAG = 'x-response-poison'

export function applyWitchPotionSelection(
  inputs: Record<string, ActionInputValue>,
  tag: string,
  value: ActionInputValue,
  availableTags: ReadonlySet<string>,
): Record<string, ActionInputValue> {
  const next = { ...inputs, [tag]: value }
  if (Number(value) === -1)
    return next

  const otherTag = tag === WITCH_ANTIDOTE_TAG
    ? WITCH_POISON_TAG
    : tag === WITCH_POISON_TAG
      ? WITCH_ANTIDOTE_TAG
      : null

  if (otherTag && availableTags.has(otherTag))
    next[otherTag] = -1

  return next
}

export function hasConflictingWitchPotionSelection(
  inputs: Record<string, ActionInputValue>,
): boolean {
  const antidote = inputs[WITCH_ANTIDOTE_TAG]
  const poison = inputs[WITCH_POISON_TAG]

  return antidote !== undefined
    && poison !== undefined
    && Number(antidote) !== -1
    && Number(poison) !== -1
}
